import React from 'react';
import ProductList from './product-list'
import Button from './button';

class ShopProducts extends React.Component {

	render() {

		let data = this.props.data;
		let products = this.props.data.products.length ? this.props.data.products : false;
		let headerText = this.props.headerText;

		return (
			<div className="section__layout">

				{this.props.showHeader == true &&
					<div className="section__header">					
					{headerText 
						? <h2 className="header--with-branding">{headerText}</h2>
						: <h2 className="header--with-branding">{data.name}</h2>
					}		
					</div>
				}

				{products.length > 0
					? <ProductList products={products}/>
					: <p>{wp_core.i18n.no_products_in_category}</p>
				}

				{this.props.showCta == true && products.length > 0 &&
					<Button cssClass="section__cta" url={data.url} label={wp_core.i18n.cta_products} />
				}				
				
			</div>

		);
	}
}	

export default ShopProducts;